// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-for-not-cancellable[data-v-5d551cce]{font-size:18px}@media screen and (max-width:320px){.message-for-not-cancellable[data-v-5d551cce]{font-size:15px}}.mypage__order__detail--preorder[data-v-5d551cce]{color:#f06292}", ""]);
// Exports
module.exports = exports;
